export default {
  // [利用履歴照会]
  // 取引種別：バリューチャージ(020)
  CARD_USAGE_SETTLEMENT_KBN_VALUE_CHARGED: '020',

  // [利用履歴照会]
  // 取引種別：バリュー利用(030)
  CARD_USAGE_SETTLEMENT_KBN_VALUE_USED: '030',

  // [利用履歴照会]
  // 通常チャージフラグ：通常チャージしていない
  CHARGE_USED_HISTORY_NORMAL_CHARGED_UNCHARGED: 0,
  // 通常チャージフラグ：通常チャージ済み
  CHARGE_USED_HISTORY_NORMAL_CHARGED_CHARGED: 1,

  // [残高チャージ]
  // DT洗車バリューチャージAPI エラーコード：「バリュー残高の上限を超えています。」
  VALUE_CHARGE_EXCEED_LIMIT_ERROR_RESPONSE: 'T0406',

  // DT洗車クーポンAPI デバイスタイプ：iOS
  CARWASH_COUPON_API_DTYPE_IOS: 'i',

  // DT洗車クーポンAPI デバイスタイプ：Android
  CARWASH_COUPON_API_DTYPE_ANDROID: 'a'
}
